import { render } from "./ChangeLiburEoView.vue?vue&type=template&id=45a049ee"
import script from "./ChangeLiburEoView.vue?vue&type=script&lang=js"
export * from "./ChangeLiburEoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__